import React, { useState } from "react";
import { scaleImage } from "../../utils/scaleImage";
import "./InnovationContainer.scss";
import { SkeletonImage } from "../@shared/SkeletonImage";

interface CardFields {
  BgImage: {
    value: {
      src: string;
      alt: string;
      width: string;
      height: string;
    };
  };
  FwImage: {
    value: {
      src: string;
      alt: string;
      width: string;
      height: string;
    };
  };
  Link: {
    value: {
      text: string;
      anchor: string;
      linktype: string;
      class: string;
      title: string;
      href: string;
      querystring: string;
    };
  };
  Title: {
    value: string;
  };
}

interface Card {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: CardFields;
}

const InnovationContainer = (props: {
  fields: {
    Cards: Card[];
    Title: {
      value: string;
    };
  };
}) => {
  const [hoveredCard, setHoveredCard] = useState<string | null>(null);

  return (
    <div className="InnovationContainer">
      <div className="InnovationContainer__header">
        <h1
          className="InnovationContainer__main-title"
          dangerouslySetInnerHTML={{ __html: props.fields.Title.value }}
          aria-label={props.fields.Title.value}
        />
      </div>

      <div className="InnovationContainer__cards">
        {props.fields.Cards.map((card) => (
          <div className="InnovationContainer__card-wrapper" key={card.id}>
            <div
              className="InnovationContainer__card"
              onMouseEnter={() => setHoveredCard(card.id)}
              onMouseLeave={() => setHoveredCard(null)}
              aria-label={`Link to ${card.fields.Title.value}`}
            >
              <SkeletonImage
                src={scaleImage(
                  card.fields.BgImage.value.src?.replace(/\?.*$/, ""),
                  480,
                  1,
                )}
                alt={card.fields.BgImage.value.alt}
                width={card.fields.BgImage.value.width}
                height={card.fields.BgImage.value.height}
                wrapperClassName="InnovationContainer__card-background"
              >
                <span />
              </SkeletonImage>

              <div
                className={`InnovationContainer__card-content ${
                  hoveredCard === card.id ? "hovered" : ""
                }`}
              >
                <h3 className="InnovationContainer__card-title">
                  {card.fields.Title.value}
                </h3>

                {hoveredCard === card.id ? (
                  <a
                    href={
                      card.fields?.Link?.value?.href +
                      (card?.fields?.Link?.value?.querystring ?? "")
                    }
                    className="ga4-click-ui-products-list InnovationContainer__card-cta"
                  >
                    {card.fields.Link.value.text}
                  </a>
                ) : null}
              </div>
            </div>
            <div className="InnovationContainer__card-engine-wrapper">
              <img
                loading="lazy"
                className="InnovationContainer__card-engine"
                src={card.fields.FwImage.value.src}
                alt={card.fields.FwImage.value.alt}
                width={card.fields.FwImage.value.width}
                height={card.fields.FwImage.value.height}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InnovationContainer;
